import { ClientProps, PriceProductProps, TaxSubstitutionProps } from '@/types';
import { calcPrice } from '@/shared';

export interface SyncedDiscountResult {
  price: number;
  saldoAFaturar: number;
}

/**
 * Recalcula o resultado de aplicar `targetPercent` sobre o preço-base de UMA porção específica de um
 * produto (kit completo com desconto de combo, kit incompleto/excedente com preço normal, etc.),
 * espelhando a mesma fórmula usada em ContentModalFlex (`calcPrices`/`setDiscountPrice`) — para
 * propagar uma única % de flex entre porções do mesmo produto+embalagem no carrinho, cada uma
 * calculando seu próprio preço final a partir da sua própria base.
 */
export const computeSyncedDiscount = (
  basePriceRecord: PriceProductProps | null | undefined,
  targetPercent: number,
  selectedClientScope: ClientProps,
  substTrib: TaxSubstitutionProps[],
): SyncedDiscountResult => {
  const basePrice = Number(basePriceRecord?.VLR_PRECO) || 0;

  if (!basePriceRecord || basePrice <= 0 || !targetPercent) {
    return { price: 0, saldoAFaturar: 0 };
  }

  const baseFinal =
    Number(basePriceRecord?.VLR_FINAL ?? basePriceRecord?.VLR_PRECO_CALCULADO ?? basePrice) || 0;

  const adjustedPrice = basePrice + (basePrice / 100) * targetPercent;
  const adjustedRow: PriceProductProps = { ...basePriceRecord, VLR_PRECO: adjustedPrice };
  const calculated = calcPrice(selectedClientScope, [adjustedRow], substTrib);
  const resultRow = calculated?.[0];
  const finalPrice =
    Number(resultRow?.VLR_FINAL || resultRow?.VLR_PRECO_CALCULADO || resultRow?.VLR_PRECO || adjustedPrice) || 0;

  const diff = finalPrice - baseFinal;
  const saldoAFaturar = targetPercent > 0 ? Math.max(diff, 0) : 0;

  return { price: finalPrice, saldoAFaturar };
};
